import { CheckboxSlider } from 'ui-components/components/checkbox-slider';

import type { RequiredPropertyProps } from './types';

type BooleanPropertyToggleProps = RequiredPropertyProps<boolean> & {
  value: boolean;
};

export const BooleanPropertyToggle = ({ id, value, updateWidget }: BooleanPropertyToggleProps) => {
  return <CheckboxSlider checkboxId={id} checked={value} onChange={updateWidget} />;
};
